import { createAction, props } from '@ngrx/store';

export const monthSelected = createAction('[PlanSelection] month selected', props<{ yearMonth: string; autoCreate: boolean }>());
